import React, { createContext, useEffect, useState } from "react";
export const UserContex = createContext();
export const UserProvider = (props) => {
  const [userData, setUserData] = useState({
    user: undefined,
    token: undefined,
  });
 const [loading, setLoading] = useState(true); // Add loading state
 console.log(userData);
 
 useEffect(() => {
   const loadUserData = async () => {
     if (localStorage.getItem("auth-token")) {
       const storedUser = localStorage.getItem("user");
       const storedToken = localStorage.getItem("auth-token");

       try {
         const parsedUser = storedUser ? JSON.parse(storedUser) : undefined;

         setUserData({
           user: parsedUser,
           token: storedToken,
         });
       } catch (error) {
         console.error("Error parsing user data from localStorage:", error);
         localStorage.removeItem("user");
         localStorage.removeItem("auth-token");
       }
     }
     setLoading(false); // Done loading
   };

   loadUserData();
 }, []);
  return (
    <UserContex.Provider value={[userData, setUserData,loading,setLoading]}>
      {props.children}
    </UserContex.Provider>
  );
};
